type SvgProps = React.SVGProps<SVGSVGElement>;

export const ChatsCircle = (props: SvgProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_102_2204)">
      <path
        d="M2.96813 16.4775C2.87164 16.5051 2.76951 16.5064 2.67234 16.4813C2.57517 16.4561 2.48649 16.4055 2.41552 16.3345C2.34455 16.2635 2.29386 16.1748 2.26871 16.0777C2.24356 15.9805 2.24487 15.8784 2.27251 15.7819L3.07219 12.9816C2.29527 11.5562 2.05805 9.8986 2.40401 8.31255C2.74996 6.7265 3.65592 5.31824 4.95584 4.3459C6.25576 3.37355 7.86256 2.90224 9.48174 3.01835C11.1009 3.13446 12.624 3.83021 13.7719 4.97809C14.9198 6.12597 15.6155 7.64908 15.7317 9.26826C15.8478 10.8875 15.3765 12.4942 14.4041 13.7942C13.4318 15.0941 12.0235 16 10.4375 16.346C8.85141 16.692 7.1938 16.4547 5.76844 15.6778L2.96813 16.4775Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.63063 16.4897C8.95557 17.4121 9.47696 18.253 10.1587 18.9542C10.8405 19.6554 11.6664 20.2002 12.5794 20.5509C13.4924 20.9016 14.4706 21.0499 15.4465 20.9855C16.4224 20.921 17.3726 20.6455 18.2316 20.1778L21.0319 20.9775C21.1284 21.0051 21.2305 21.0064 21.3277 20.9813C21.4248 20.9561 21.5135 20.9055 21.5845 20.8345C21.6555 20.7635 21.7062 20.6748 21.7313 20.5777C21.7565 20.4805 21.7551 20.3784 21.7275 20.2819L20.9278 17.4816C21.4734 16.4809 21.7568 15.3584 21.7514 14.2187C21.7461 13.079 21.4523 11.9592 20.8973 10.9637C20.3424 9.96817 19.5444 9.1294 18.5778 8.52555C17.6112 7.92169 16.5074 7.57243 15.3694 7.51031"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_102_2204">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
